import type { AccountCompanyResponse, Company } from '../interfaces/company.interface';

const COMPANY_COLORS = [
  '#1e6bd6', // blue
  '#0c8a5b', // emerald
  '#b6500f', // amber-burnt
  '#6d4ed8', // violet
  '#0e7eb8', // ocean
  '#d4477a', // pink
  '#3aa66c', // green
  '#c46a1f', // orange
];

export function deriveCompanyShort(name: string | null | undefined): string {
  if (!name) return '—';
  const cleaned = name.replace(/[^a-zA-Z0-9\s]/g, ' ').trim();
  if (!cleaned) return name.slice(0, 3).toUpperCase();

  const tokens = cleaned.split(/\s+/).filter(Boolean);
  if (tokens.length >= 3) {
    return (tokens[0][0] + tokens[1][0] + tokens[2][0]).toUpperCase();
  }
  if (tokens.length === 2) {
    return (tokens[0].slice(0, 2) + tokens[1][0]).toUpperCase();
  }
  return tokens[0].slice(0, 3).toUpperCase();
}

export function deriveCompanyColor(id: number): string {
  const index = Math.abs(id) % COMPANY_COLORS.length;
  return COMPANY_COLORS[index];
}

export function mapAccountCompany(raw: AccountCompanyResponse): Company {
  const name = raw.company || `Firmă #${raw.id}`;
  return {
    id: raw.id,
    name,
    vat: raw.vat,
    isDefault: raw.isDefault,
    short: deriveCompanyShort(raw.company),
    color: deriveCompanyColor(raw.id),
  };
}
